if (!customElements.get('header-language')) {
  customElements.define('header-language', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.onOutsideClick = (event) => {
        if (!this.contains(event.target)) this.details.open = false;
      };
      this.onKeydown = (event) => {
        if (event.key === 'Escape' && this.details.open) {
          this.details.open = false;
          this.querySelector('summary').focus();
          event.stopPropagation();
        }
      };
      this.onFocusout = (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.details.open = false;
      };
      document.addEventListener('click', this.onOutsideClick);
      this.addEventListener('keydown', this.onKeydown);
      this.addEventListener('focusout', this.onFocusout);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.onOutsideClick);
      this.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('focusout', this.onFocusout);
    }
  });
}
